import Model, { attr } from "@ember-data/model";
import { Type } from "@warp-drive/core-types/symbols";

export default class DataCenterModel extends Model {
  @attr declare name: string;

  @attr declare hasNetworkSupport: boolean;
  @attr declare hasFileStorageVolumeSupport: boolean;

  @attr declare hasVmwareSupport: boolean;
  @attr declare hasKvmSupport: boolean;
  @attr declare hasObjectStorageInstanceSupport: boolean;
  @attr declare hasPrivateNetworkSupport: boolean;
  @attr declare hasDatabaseSupport: boolean;
  @attr declare hasFixedPlanSupport: boolean;
  @attr declare hasRoutableSegmentSupport: boolean;
  @attr declare hasBlockStorageVolumeSupport: boolean;

  [Type] = "data-center" as const;
}

export const dataCenters = [
  {
    id: "dc-ams1",
    name: "Amsterdam",
    hasNetworkSupport: true,
    hasVmwareSupport: true,
    hasKvmSupport: false,
    hasFileStorageVolumeSupport: false,
    hasObjectStorageInstanceSupport: false,
    hasPrivateNetworkSupport: false,
    hasDatabaseSupport: false,
    hasFixedPlanSupport: false,
    hasRoutableSegmentSupport: false,
    hasBlockStorageVolumeSupport: false,
  },
  {
    id: "dc-fbg1",
    name: "Falkenberg",
    hasNetworkSupport: true,
    hasVmwareSupport: true,
    hasKvmSupport: true,
    hasFileStorageVolumeSupport: true,
    hasObjectStorageInstanceSupport: true,
    hasPrivateNetworkSupport: true,
    hasDatabaseSupport: true,
    hasFixedPlanSupport: true,
    hasRoutableSegmentSupport: true,
    hasBlockStorageVolumeSupport: true,
  },
  {
    id: "dc-lon1",
    name: "London",
    hasNetworkSupport: false,
    hasVmwareSupport: true,
    hasKvmSupport: false,
    hasFileStorageVolumeSupport: false,
    hasObjectStorageInstanceSupport: false,
    hasPrivateNetworkSupport: false,
    hasDatabaseSupport: false,
    hasFixedPlanSupport: false,
    hasRoutableSegmentSupport: false,
    hasBlockStorageVolumeSupport: false,
  },
  {
    id: "dc-osl1",
    name: "Oslo",
    hasNetworkSupport: true,
    hasVmwareSupport: true,
    hasKvmSupport: false,
    hasFileStorageVolumeSupport: false,
    hasObjectStorageInstanceSupport: false,
    hasPrivateNetworkSupport: false,
    hasDatabaseSupport: false,
    hasFixedPlanSupport: false,
    hasRoutableSegmentSupport: false,
    hasBlockStorageVolumeSupport: false,
  },
  {
    id: "dc-sto1",
    name: "Stockholm",
    hasNetworkSupport: true,
    hasVmwareSupport: true,
    hasKvmSupport: true,
    hasFileStorageVolumeSupport: true,
    hasObjectStorageInstanceSupport: true,
    hasPrivateNetworkSupport: true,
    hasDatabaseSupport: true,
    hasFixedPlanSupport: false,
    hasRoutableSegmentSupport: true,
    hasBlockStorageVolumeSupport: false,
  },
  {
    id: "dc-oul1",
    name: "Oulu",
    hasNetworkSupport: true,
    hasVmwareSupport: true,
    hasKvmSupport: true,
    hasFileStorageVolumeSupport: false,
    hasObjectStorageInstanceSupport: false,
    hasPrivateNetworkSupport: true,
    hasDatabaseSupport: true,
    hasFixedPlanSupport: false,
    hasRoutableSegmentSupport: false,
    hasBlockStorageVolumeSupport: false,
  },
];
